export default __webpack_public_path__ + "media/images/mailer/wordmark-1498a9b7895632c8ca1618b26470201d.png";